/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import { Flex, Heading } from "@theme-ui/components";
import { Tag } from "../atoms";
import { colors, typography } from "../../styles/theme";

const PageHeading = (props) => {
  const bgColor = props.bgColor || colors.secondaryGreenMain;
  const backgroundImage = props.image
    ? `url(${props.image}) no-repeat bottom center`
    : undefined;

  return (
    <Flex
      sx={{
        ...styles.container,
        backgroundColor: bgColor,
        ...(backgroundImage ? { background: backgroundImage } : {}),
      }}
    >
      {props?.tag && (
        <Tag label={props.tag} bgColor="green" customStyles={styles.tag} />
      )}
      <Heading as="h1" sx={styles.heading}>
        {props.children}
      </Heading>
    </Flex>
  );
};

const styles = {
  container: {
    flexDirection: "column",
    justifyContent: "flex-end",
    alignContent: "center",
    alignItems: "center",
    minHeight: "15.063rem",
    pt: "3rem",
    px: [3, 3, 4, "9rem"],
    pb: "2.875rem",
  },
  tag: {
    mb: 3,
  },
  heading: {
    ...typography.h1,
    textAlign: "center",
  },
};

export default PageHeading;